<script setup lang="ts">
import { useRouter } from 'vue-router'
import DefaultLayout from '@/layouts/DefaultLayout.vue'
import EmptyState from '@lib/components/shared/EmptyState.vue'
import BBtn from '@lib/components/base/BBtn.vue'

const router = useRouter()
</script>

<template>
    <DefaultLayout>
        <EmptyState title="Stránka nenalezena" subtitle="Tato URL neexistuje.">
            <template #cta>
                <BBtn label="Zpět na Dashboard" @click="router.push('/')" />
            </template>
        </EmptyState>
    </DefaultLayout>
</template>
